import React from 'react';
import Chart from 'react-apexcharts';
import formatDataLabel from './formatDataLabel';
export default function VerticalBarChart(_ref) {
  let {
    data,
    dataName,
    colors,
    showLables = true,
    showLegend = true,
    groups = [],
    customLabels = [],
    formatter = number => window.MARKET_CONSTANTS.CURRENCY_FORMATTER.format(number),
    lablePosition = 'right',
    opposite,
    isPercentageData = false
  } = _ref;
  const dataColor = '#666E7E';
  const seriesData = data.map(singleBarData => ({
    ...singleBarData,
    x: singleBarData.label,
    y: singleBarData.value
  }));
  const series = [{
    name: dataName,
    data: seriesData
  }];
  const chartMinWidth = data.length > 0 ? `${160 * data.length}px` : '';
  const maxValue = Math.max(...data.map(d => Number(d.value)));
  const threshold = maxValue * 0.1;
  const options = {
    chart: {
      type: 'bar',
      height: 350
    },
    grid: {
      padding: {
        left: -5,
        right: -5
      }
    },
    legend: {
      show: showLegend,
      position: lablePosition,
      offsetY: 110
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        distributed: true,
        columnWidth: '50%',
        dataLabels: {
          position: 'top'
        }
      }
    },
    colors: colors,
    dataLabels: {
      enabled: true,
      enabledOnSeries: [0],
      offsetY: -30,
      style: {
        fontFamily: 'Franklin Gothic Book, sans-serif',
        fontSize: '16px',
        colors: [dataColor]
      },
      formatter: val => formatDataLabel(val, isPercentageData),
      background: {
        enabled: false
      }
    },
    xaxis: {
      group: {
        groups: groups
      },
      labels: {
        show: showLables,
        style: {
          colors: '#666e7e',
          fontSize: '12px',
          fontWeight: 'bold',
          fontFamily: 'Franklin Gothic Book, sans-serif'
        }
      }
    },
    yaxis: {
      opposite: opposite,
      labels: {
        style: {
          colors: '#666e7e',
          fontSize: '14px',
          fontFamily: 'Franklin Gothic Book, sans-serif'
        },
        offsetX: -15,
        formatter: formatter
      }
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: formatter
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: chartMinWidth
    }
  }, /*#__PURE__*/React.createElement(Chart, {
    options: options,
    series: series,
    type: "bar",
    height: "360px"
  }));
}